import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BidderModel, HCSOBidderModel, HPDBidderModel,MKEBidderModel, BidderAgreementModel } from '../models/bidder';
import { ESellerModel } from '../models/eseller';
import { forkJoin, Observable } from 'rxjs';
import { ReservedPriceStatusModel } from '../models/reservedPriceStatus';
import { MoveSingleAuctionModel } from '../models/moveSingleAuction';
import { MoveAuctionModel } from '../models/moveAuction';
import { BidderRequestModel } from 'src/app/models/bidderapprovalrequest'
import { CancelRequestModel } from '../models/cancelRequestModel';
import { environment } from 'src/environments/environment.local';

@Injectable({ providedIn: 'root' })
export class BidderService {
    constructor(private http: HttpClient) { }

    register(bidder: BidderModel) {
        return this.http.post(`${environment.BASE_API_URL}bidder/savebidder`, bidder);
    }

    getBidderHistory(userId: number, saleNo: string, vin: string, makeId: string, modelId: string, date: string, amount: string, enterpriseId: string, storageLotId: string, auctionDateId: string, auctionsWon: boolean, auctionsLost: boolean) {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/getBidderHistory?userId=` + userId + `&saleNo=` + saleNo + `&vin=` + vin + `&makeId=` + makeId + `&modelId=` + modelId + `&date=` + date + `&amount=` + amount + `&enterpriseId=` + enterpriseId + `&storageLotId=`+ storageLotId + `&auctionDateId=` + auctionDateId + `&auctionsWon=` + auctionsWon + `&auctionsLost=` + auctionsLost);
    }

    getBidHistory(userId: number, productId: number) {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/getBidHistory?userId=` + userId + `&productId=` + productId);
    }

    getBidderWonUnpaidHistory(enterpriseId: string, bidderId: string, auctionDateId: number, searchId: number, showReservedPriceNotMet: boolean, showUnpaidOver7Days: boolean) {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/getBidderWonUnpaid?enterpriseId=` + enterpriseId + `&bidderId=` + bidderId + `&auctionDateId=` + auctionDateId + `&searchId=` + searchId + `&showReservedPriceNotMet=` + showReservedPriceNotMet + `&showUnpaidOver7Days=` + showUnpaidOver7Days);
    }

    getBidderWonUnpaidSummary(enterpriseId: string, bidderId: string, isEnterprise: boolean, storageLotId: number) {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/getBidderWonUnpaidSummary?enterpriseId=` + enterpriseId + `&bidderId=` + bidderId + `&isEnterprise=` + isEnterprise + `&storageLotId=` + storageLotId);
    }

    getBidderDashboard(enterpriseId, bidderId, isEnterprise, storageLotId): Observable<[any, any, any, any]> {
        let getUpcomingAuction = this.http.get<any>(`${environment.BASE_API_URL}bidder/GetUpcomingAuction?enterpriseId=` + enterpriseId + `&storageLotId=` + storageLotId);
        let getCurrentAuction = this.http.get<any>(`${environment.BASE_API_URL}bidder/GetCurrentAuction?enterpriseId=` + enterpriseId + `&storageLotId=` + storageLotId);
        let getCurrentBidVehicles = this.http.get<any>(`${environment.BASE_API_URL}bidder/GetCurrentBidVehicles?bidderId=` + bidderId);
        let getBidderWonUnpaidSummary = this.http.get<any>(`${environment.BASE_API_URL}bidder/getBidderWonUnpaidSummary?enterpriseId=` + enterpriseId + `&bidderId=` + bidderId + `&isEnterprise=` + isEnterprise + `&storageLotId=` + storageLotId);
        return forkJoin([getUpcomingAuction, getCurrentAuction, getCurrentBidVehicles, getBidderWonUnpaidSummary]);
    }

    getUpcomingCurrentAuctionEnterprise(enterpriseId, storageLotId): Observable<[any, any]> {
        let getUpcomingAuction = this.http.get<any>(`${environment.BASE_API_URL}bidder/GetUpcomingAuction?enterpriseId=` + enterpriseId + `&storageLotId=` + storageLotId + `&showNotPublished=true`);
        let getCurrentAuction = this.http.get<any>(`${environment.BASE_API_URL}bidder/GetCurrentAuction?enterpriseId=` + enterpriseId + `&storageLotId=` + storageLotId);
        return forkJoin([getUpcomingAuction, getCurrentAuction]);
    }

    closeAuction(esellerModel: ESellerModel) {
        return this.http.post(`${environment.BASE_API_URL}enterprise/PushCloseAuctionToDlms`, esellerModel);
    }
    ExportCloseAuctionToDlms(esellerModel: ESellerModel) {
        return this.http.post(`${environment.BASE_API_URL}enterprise/ExportCloseAuctionToDlms`, esellerModel);
    }
    loadAuctionVehicleList(pageNum, pageSize, enterpriseId, bidderId, myFavorite, myBids): Observable<any> {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/SelectCurrentAuctionVehicles?pageNum=` + pageNum + `&pageSize=` + pageSize + `&enterpriseId=` + enterpriseId + `&bidderId=` + bidderId + `&myFavorite=` + myFavorite + `&myBids=` + myBids);
    }

    saveProductFavorite(productId, userId): Observable<any> {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/SaveProductFavorite?productId=` + productId + `&userId=` + userId);
    }

    removeProductFavorite(productId, userId): Observable<any> {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/RemoveProductFavorite?productId=` + productId + `&userId=` + userId);
    }
    getReservedPriceNotMetSummary(auctiondateId: number, bidderId: number) {
        return this.http.get<any>(`${environment.BASE_API_URL}enterprise/GetReservedPriceNotMetSummary?auctionDateId=` + auctiondateId + `&bidderId=` + bidderId);
    }
    updateReservedPriceMetStatus(rmodel: ReservedPriceStatusModel) {
        return this.http.post(`${environment.BASE_API_URL}enterprise/UpdateReservedPriceMetStatus`, rmodel);
    }
    moveAuctionIndividualRecordToDlms(rmodel: MoveSingleAuctionModel) {
        return this.http.post(`${environment.BASE_API_URL}enterprise/MoveAuctionIndividualRecordToDlms`, rmodel);
    }
    moveAuctionDateRecordsToDlms(rmodel: MoveAuctionModel) {
        return this.http.post(`${environment.BASE_API_URL}enterprise/MoveAuctionDateRecordsToDlms`, rmodel);
    }

    CheckPhoneVerified(bidderid) {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/GetCheckPhoneVerified?bidderId=` + bidderid);
    }
    requestBidApproval(bidRequestApproval: BidderRequestModel) {
        return this.http.post(`${environment.BASE_API_URL}bidder/saveBidderApprovalRequest`, bidRequestApproval);
    }
    GetBidderRequests(bidderid, sellerid) {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/GetBidderRequests?bidderId=` + bidderid + `&sellerId=` + sellerid);
    }
    GetBidderRequestSellers() {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/GetBidderRequestSellers`);
    }

    BidderRequestEligibilityCheck(sellerId, bidderid) {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/BidderRequestEligibilityCheck?SellerId=` + sellerId + `&bidderId=` + bidderid);
    }

    CancelBidderRequest(cancelRequestModel: CancelRequestModel) {
        return this.http.post(`${environment.BASE_API_URL}bidder/CancelBidderRequest`, cancelRequestModel);
    }

    BidderBidEligibilityCheck(productId, bidderId, RequestId, UserId,SellerId) {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/BidderBidEligibilityCheck?productId=` + productId + `&bidderId=` + bidderId + `&RequestId=` + RequestId + `&UserId=` + UserId+ `&SellerId=` + SellerId);
    }

    BidderBidEligibilityCheckMessage(productId, bidderId, RequestId, UserId,SellerId,GetAllMsg) {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/BidderBidEligibilityCheck?productId=` + productId + `&bidderId=` + bidderId + `&RequestId=` + RequestId + `&UserId=` + UserId+ `&SellerId=` + SellerId+ `&GetAllMsg=` + GetAllMsg);
    }

    GetGTABidderDocs(gtaRequestId): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}bidder/GetGTABidderDocs?gtaRequestId=${gtaRequestId}`);
    }

    DeleteBidderDocs(docId): Observable<any> {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/DeleteBidderDocs?docId=${docId}`);
    }

    GetBidderRequestMessages(gtaRequestId): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}bidder/GetBidderRequestMessages?gtaRequestId=${gtaRequestId}`);
    }

    GetAuditBidderRequests(gtaRequestId): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}bidder/GetAuditBidderRequests?requestId=${gtaRequestId}`);
    }

    saveQuestion(data: any) {
        return this.http.post(`${environment.BASE_API_URL}bidder/saveQuestion`, data);
    }

    ValidateBiddingEligibleCheck(bidderId, EnterpriseId, ProductId) {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/ValidateBiddingEligible?EnterpriseId=` + EnterpriseId + `&BidderId=` + bidderId + `&ProductId=` + ProductId);
    }

    getSellerSpecificEditProfiles(bidderid) {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/GetSellerSpecificEditProfiles?BidderId=` + bidderid);
    }

    SaveHPDBidder(bidder: HPDBidderModel) {
        return this.http.post(`${environment.BASE_API_URL}bidder/SaveHPDBidder`, bidder);
    }

    HPDLicenseCheck(licenseNo, enterpriseId) {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/HPDLicenseCheck?licenseNo=` + licenseNo + `&enterpriseId=` + enterpriseId);
    }

    BidderCommonBidEligibilityCheck(enterpriseId, bidderId) {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/BidderCommonBidEligibilityCheck?enterpriseId=` + enterpriseId + `&bidderId=` + bidderId);
    }

    SelectNotification(enterpriseId) {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/SelectNotification?enterpriseId=` + enterpriseId);
    }

    GetBidderApprovalRequest(BidderId: number, RequestId: number) {
        return this.http.get<any>(`${environment.BASE_API_URL}bidder/GetBidderApprovalRequest?BidderId=${BidderId}&RequestId=${RequestId}`);
    }

    ValidateUserUpdatingProfileFromCommonConfiguration(model: any) {
        return this.http.post<any>(`${environment.BASE_API_URL}bidder/ValidateUserUpdatingProfileFromCommonConfiguration`, model);
    }

    getAuctionInformation(auctionDateId): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}bidder/GetAuctionInformation?AuctionDateId=${auctionDateId}`);
    }
    
    getBidsHistory(bidderId,productId): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}bidder/GetBidsHistoryByBidderId?BidderId=${bidderId}&ProductId=${productId}`);
    }

    selectBidderInvoices(sellerId, bidderId, storageLotId, auctionDateId, pageNum, pageSize): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}bidder/SelectBidderInvoices?PageNum=${pageNum}&PageSize=${pageSize}&SellerId=${sellerId}&BidderId=${bidderId}&StorageLotId=${storageLotId}&AuctionDateId=${auctionDateId}`);
    }

    selectBidderPaidVehicles(paymentId, bidderId, pageNum, pageSize): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}bidder/SelectBidderPaidVehicles?PageNum=${pageNum}&PageSize=${pageSize}&PaymentId=${paymentId}&BidderId=${bidderId}`);
    }
    SaveMKEBidder(bidder: MKEBidderModel) {
        return this.http.post(`${environment.BASE_API_URL}bidder/SaveMKEBidder`, bidder);
    }
    
    blockBidder(bidderId: number, userId: number, auctionDateId :number | undefined, enterpriseId :number  | undefined): Observable<any> {
        return this.http.post<any>(`${environment.BASE_API_URL}bidder/BlockBidder`, { BidderId: bidderId, UserId: userId, AuctionDateId: auctionDateId, EnterpriseId: enterpriseId  });
    }

    unblockBidder(bidderId: number, userId: number, auctionDateId :number | undefined, enterpriseId :number  | undefined): Observable<any> {
        return this.http.post<any>(`${environment.BASE_API_URL}bidder/UnBlockBidder`, { BidderId: bidderId, UserId: userId, AuctionDateId: auctionDateId, EnterpriseId: enterpriseId });
    }
        
    SaveHCSOBidder(bidder: HCSOBidderModel) {
        return this.http.post(`${environment.BASE_API_URL}bidder/SaveHCSOBidder`, bidder);
    }
    ValidateUsername(obj: { UserName: string }) {
        return this.http.post(`${environment.BASE_API_URL}bidder/ValidateUsername`, obj);
    }

    ValidatePDF(obj: any) {
        return this.http.post(`${environment.BASE_API_URL}bidder/ValidatePDF`, obj);
    }

    GetSellerDetails(enterpriseId: number): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}enterprise/GetSellerDetails?enterpriseId=${enterpriseId}`);
    }

    GetSellerDetailsFromGuid(enterpriseGUID: string): Observable<any> {
        return this.http.get(`${environment.BASE_API_URL}enterprise/GetSellerDetails?enterpriseGUID=${enterpriseGUID}`);
    }
    
    SaveBidderAgreement(bidderAgreement: BidderAgreementModel): Observable<any> {
        return this.http.post<any>(`${environment.BASE_API_URL}bidder/SaveBidderAgreement`, bidderAgreement);
    }
}

